// GDPR-first Google Analytics 4 (gtag.js). Mirrors the Mixpanel wrapper: nothing
// tracks until the visitor grants the `analytics` cookie category. Uses Google
// Consent Mode v2 (default denied) and only injects the gtag script after
// consent, so no GA request fires before opt-in. No-ops when the measurement ID
// is absent (dev/test/unconfigured), keeping those environments silent.

const measurementId = () =>
  document.querySelector('meta[name="ga-measurement-id"]')?.content

let id = null
let scriptLoaded = false

function gtag() {
  window.dataLayer.push(arguments)
}

export function initGoogleAnalytics() {
  if (id) return
  const mid = measurementId()
  if (!mid) return // unconfigured environment — stay silent
  id = mid

  window.dataLayer = window.dataLayer || []
  // Consent Mode v2 — deny everything until the visitor opts in.
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  })
  gtag("js", new Date())
  // Block GA hits entirely until consent loads the script.
  window[`ga-disable-${id}`] = true
}

export function enableGoogleAnalytics() {
  if (!id) return
  window[`ga-disable-${id}`] = false
  gtag("consent", "update", { analytics_storage: "granted" })

  if (!scriptLoaded) {
    scriptLoaded = true
    const s = document.createElement("script")
    s.async = true
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    document.head.appendChild(s)
    gtag("config", id)
  }
}

export function disableGoogleAnalytics() {
  if (!id) return
  window[`ga-disable-${id}`] = true
  gtag("consent", "update", { analytics_storage: "denied" })
}
